<div class="legal-wrapper">
  <div class="hero-background"></div>
  <div class="overlay"></div>

  <div class="legal-container">
    <div class="glass-card legal-card">
      
      <div class="legal-header">
        <h1>Connect Your Calendar</h1>
        <p class="last-updated">Learn how to synchronize your events with YourNotes</p>
      </div>

      <div class="legal-body">
        
        <p class="intro-text">
          To get the most out of your dashboard, you can connect your existing calendars. YourNotes supports three different integration methods. Choose the one that matches your calendar provider below.
        </p>

        <section class="support-section">
          <div class="section-title-wrapper">
            <span class="step-badge">1</span>
            <h2>Google Calendar</h2>
          </div>
          <p>
            The easiest way to sync your Google Calendar is through our secure OAuth integration. This grants YourNotes the ability to display and manage your events without ever seeing your password.
          </p>
          <div class="guide-box">
            <h3>How to connect:</h3>
            <ol class="guide-list">
              <li>Navigate to your <strong>Account Settings</strong> in YourNotes.</li>
              <li>Click on the <strong>Connect Google Calendar</strong> button.</li>
              <li>Log in to your Google account and grant the requested permissions.</li>
              <li>Your events will automatically start appearing on your dashboard.</li>
            </ol>
          </div>
        </section>

        <section class="support-section">
          <div class="section-title-wrapper">
            <span class="step-badge">2</span>
            <h2>iCalendar (Webcal URL)</h2>
          </div>
          <p>
            If you use Apple iCloud or Microsoft 365, you can easily link your calendar using a public iCal/Webcal link.
          </p>

          <div class="provider-sub-box">
            <h3>Apple iCloud Calendar</h3>
            <p>To share your Apple calendar, you need to generate a link via iCloud:</p>
            <ol class="guide-list">
              <li>Go to <a href="https://www.icloud.com" target="_blank" rel="noopener">icloud.com</a> and sign in.</li>
              <li>Open the <strong>Calendar</strong> app and click the wireless icon next to the calendar you want to share.</li>
              <li>Check the box for <strong>Public Calendar</strong>.</li>
              <li>Copy the generated URL (it usually starts with <code>webcal://</code>).</li>
              <li>Paste this URL directly into your YourNotes settings.</li>
            </ol>
          </div>

          <div class="provider-sub-box">
            <h3>Microsoft 365 / Outlook</h3>
            <p>To use your Outlook or Microsoft 365 calendar, you need to publish it:</p>
            <ol class="guide-list">
              <li>Log in to Outlook on the web.</li>
              <li>Go to <strong>Settings</strong> (gear icon) &gt; <strong>View all Outlook settings</strong>.</li>
              <li>Navigate to <strong>Calendar</strong> &gt; <strong>Shared calendars</strong>.</li>
              <li>Under the <strong>Publish a calendar</strong> section, select the calendar you wish to link.</li>
              <li>Set the permissions to <strong>Can view all details</strong>.</li>
              <li>Click <strong>Publish</strong>, copy the generated <strong>ICS link</strong>, and paste it into YourNotes.</li>
            </ol>
          </div>
        </section>

        <section class="support-section">
          <div class="section-title-wrapper">
            <span class="step-badge">3</span>
            <h2>CalDAV Integration</h2>
          </div>
          <p>
            For open-source and self-hosted environments (such as Nextcloud, Baïkal, or Apple Server), YourNotes supports native CalDAV synchronization.
          </p>
          <div class="guide-box">
            <h3>What you will need:</h3>
            <ul class="prohibited-list">
              <li><strong>Server URL:</strong> The full URL to your personal calendar path (e.g., <code>https://nextcloud.example.com/remote.php/dav/calendars/username/personal/</code>).</li>
              <li><strong>Username:</strong> Your CalDAV account username.</li>
              <li><strong>Password / App Token:</strong> Your password. For security, we highly recommend generating a dedicated <em>App Password</em> in your server settings.</li>
            </ul>
          </div>
        </section>

        <section class="contact-section">
          <h2>Need more help?</h2>
          <p>
            If you are experiencing any issues while connecting your calendar, please do not hesitate to reach out to our support team:
          </p>
          <a href="mailto:info@yournotes.nl" class="email-link">info [] yournotes.nl</a>
        </section>

      </div>
    </div>
  </div>

  <mat-toolbar class="bottom-toolbar">
    <button mat-flat-button (click)="back()">
      <mat-icon>arrow_back</mat-icon> Back
    </button>
  </mat-toolbar>
</div>